import {
  addMonths, endOfMonth, endOfQuarter, format, eachMonthOfInterval,
  isWithinInterval, isBefore, isAfter, parseISO, startOfMonth,
  startOfQuarter, startOfYear, subMonths, subQuarters, subYears,
  subDays,
  addDays,
  isSameMonth
} from "date-fns"
import { today } from 'AppReact';

const checkDateInRange = (date, start, end) => {
  if (!date) return;
  return isWithinInterval(parseISO(date), {
    start: parseISO(start),
    end: parseISO(end),
  });
};

export const getInspectionsLabels = (selectedDate) => {
  let labels = [];

  if (selectedDate === 'lastMonth') {
    const firstDate = subDays(today(), 29);
    labels = [
      `${format(firstDate, 'MMM dd')}-${format(addDays(firstDate, 6), isSameMonth(firstDate, addDays(firstDate, 6)) ? 'dd' : 'MMM dd')}`,
      `${format(addDays(firstDate, 7), 'MMM dd')}-${format(addDays(firstDate, 13), isSameMonth(addDays(firstDate, 13), addDays(firstDate, 7)) ? 'dd' : 'MMM dd')}`,
      `${format(addDays(firstDate, 14), 'MMM dd')}-${format(addDays(firstDate, 20), isSameMonth(addDays(firstDate, 14), addDays(firstDate, 20)) ? 'dd' : 'MMM dd')}`,
      `${format(addDays(firstDate, 21), 'MMM dd')}-${format(addDays(firstDate, 29), isSameMonth(addDays(firstDate, 21), addDays(firstDate, 29)) ? 'dd' : 'MMM dd')}`,
    ]
  }

  if (selectedDate === 'lastQuarter') {
    const lastQuarterStart = startOfQuarter(subQuarters(today(), 1));
    const lastQuarterEnd = endOfQuarter(subQuarters(today(), 1));

    labels = eachMonthOfInterval({ start: lastQuarterStart, end: lastQuarterEnd }).map((date) => format(date, "MMMM"));
  }

  if (selectedDate === 'lastYear') {
    const end = subMonths(startOfMonth(today()), 1);
    const start = subMonths(end, 11);

    labels = eachMonthOfInterval({ start, end }).map((date) => format(date, "MMMM"));
  }

  return labels;
}



export const getCompletedInspectionsGraphData = ({ selectedDate, inspections, selectedPropertyIds }) => {
  let data = {};

  if (selectedDate === 'lastMonth') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0, 0];
    })

    const firstDate = subDays(today(), 29);

    inspections.map(i => {
      if (!i.completion_date || !selectedPropertyIds?.includes(i.property_id)) {
        return;
      }

      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(firstDate, 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 6), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][0] += 1;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 7), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 13), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][1] += 1;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 14), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 20), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][2] += 1;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 21), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 29), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][3] += 1;
      }
    })
  }

  if (selectedDate === 'lastQuarter') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0];
    })

    const lastQuarterStart = startOfQuarter(subQuarters(today(), 1));

    inspections.map(i => {
      if (!i.completion_date || !selectedPropertyIds?.includes(i.property_id)) {
        return;
      }

      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(lastQuarterStart), 'yyyy-MM-dd'), format(endOfMonth(lastQuarterStart), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][0] += 1;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][1] += 1;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][2] += 1;
      }
    })
  }

  if (selectedDate === 'lastYear') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    })


    const lastYearStart = startOfMonth(subMonths(today(), 12));

    inspections.map(inspection => {
      if (!inspection.completion_date || !selectedPropertyIds?.includes(inspection.property_id)) {
        return;
      }

      for (let i = 0; i < 12; i++) {
        let inspectionDate = format(new Date(inspection.completion_date), 'yyyy-MM-dd');
        let startDate = format(startOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');
        let endDate = format(endOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');

        if (checkDateInRange(inspectionDate, startDate, endDate)) {
          data[`${inspection.property_id}`][i] += 1;
        }
      }
    })
  }

  return data;
}

export const getCompletedInspectionsInInterval = ({ selectedDate, inspections }) => {
  let startDate = today();
  let endDate = today();

  if (!selectedDate) return [];

  if (selectedDate === 'lastMonth') {
    startDate = subDays(today(), 29);
    endDate = today();
  }

  if (selectedDate === 'lastQuarter') {
    startDate = startOfQuarter(subQuarters(today(), 1));
    endDate = endOfQuarter(subQuarters(today(), 1));
  }

  if (selectedDate === 'lastYear') {

    startDate = startOfMonth(subMonths(today(), 12));
    endDate = endOfMonth(subMonths(today(), 1));
  }

  return inspections.filter(i => i.completion_date && checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(startDate, 'yyyy-MM-dd')}`, `${format(endDate, 'yyyy-MM-dd')}`))
}

export const getCancelledInspectionsInInterval = ({ selectedDate, inspections }) => {
  let startDate = today();
  let endDate = today();

  if (selectedDate === 'lastMonth') {
    startDate = subDays(today(), 29);
    endDate = today();
  }

  if (selectedDate === 'lastQuarter') {
    startDate = startOfQuarter(subQuarters(today(), 1));
    endDate = endOfQuarter(subQuarters(today(), 1));
  }

  if (selectedDate === 'lastYear') {

    startDate = startOfMonth(subMonths(today(), 12));
    endDate = endOfMonth(subMonths(today(), 1));
  }

  return inspections.filter(i => i.cancellation_date && checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(startDate, 'yyyy-MM-dd')}`, `${format(endDate, 'yyyy-MM-dd')}`))
}

export const getCancelledInspectionsGraphData = ({ selectedDate, inspections, selectedPropertyIds }) => {
  let data = {};

  if (selectedDate === 'lastMonth') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0, 0];
    })

    const firstDate = subDays(today(), 29);

    inspections.map(i => {
      if (!i.cancellation_date || !selectedPropertyIds?.includes(i.property_id)) {
        return;
      }

      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(firstDate, 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 6), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][0] += 1;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 7), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 13), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][1] += 1;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 14), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 20), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][2] += 1;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 21), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 29), 'yyyy-MM-dd')}`)) {
        data[`${i.property_id}`][3] += 1;
      }
    })
  }

  if (selectedDate === 'lastQuarter') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0];
    })

    const lastQuarterStart = startOfQuarter(subQuarters(today(), 1));

    inspections.map(i => {
      if (!i.cancellation_date) {
        return;
      }

      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(lastQuarterStart), 'yyyy-MM-dd'), format(endOfMonth(lastQuarterStart), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][0] += 1;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][1] += 1;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'))) {
        data[`${i.property_id}`][2] += 1;
      }
    })
  }

  if (selectedDate === 'lastYear') {
    selectedPropertyIds.map(id => {
      data[`${id}`] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    })


    const lastYearStart = startOfYear(subYears(today(), 1));

    inspections.map(inspection => {
      if (!inspection.cancellation_date) {
        return;
      }

      for (let i = 0; i < 12; i++) {
        let inspectionDate = format(new Date(inspection.cancellation_date), 'yyyy-MM-dd');
        let startDate = format(startOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');
        let endDate = format(endOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');

        if (checkDateInRange(inspectionDate, startDate, endDate)) {
          data[`${inspection.property_id}`][i] += 1;
        }
      }
    })
  }

  return data;
}

export const getOpenInspectionsBeforeDate = ({ allTimeOpenInspections, intervalClosedInspections, intervalEnd }) => {

  let openInspectionsInInterval = allTimeOpenInspections.filter(i => isBefore(new Date(i.creation_date), intervalEnd));

  let inspectionsCreatedBeforeIntervalStartAndClosedAfter = intervalClosedInspections.filter(i => {
    let wasCreatedBeforeIntervalEnd = isBefore(new Date(i.creation_date), intervalEnd);
    let wasClosedAfterIntervalEnd = isAfter(new Date(i.status === 'completed' ? i.completion_date : i.cancellation_date), intervalEnd);

    return wasCreatedBeforeIntervalEnd && wasClosedAfterIntervalEnd;
  })

  return [...openInspectionsInInterval, ...inspectionsCreatedBeforeIntervalStartAndClosedAfter];
}

export const getInspectionsByUnit = ({ openInspectionsByDate, cancelledInspectionsStats, completedInspectionsStats, showCancelled, showCompleted, showOpen, selectedDate, units, index }) => {
  let cancelledInspectionsByDate = [];
  let completedInspectionsByDate = [];

  if (selectedDate === 'lastMonth') {

    cancelledInspectionsByDate = [[], [], [], []];
    completedInspectionsByDate = [[], [], [], []];
    const firstDate = subDays(today(), 29);

    showCompleted && completedInspectionsStats.map(i => {
      if (!i.completion_date) {
        return;
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(firstDate, 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 6), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[0].push(i);
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 7), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 13), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[1].push(i);
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 14), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 20), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[2].push(i);
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 21), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 29), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[3].push(i);
      }
    })


    showCancelled && cancelledInspectionsStats.map(i => {
      if (!i.cancellation_date) {
        return;
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(firstDate, 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 6), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[0].push(i);
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 7), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 13), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[1].push(i);
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 14), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 20), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[2].push(i);
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), `${format(addDays(firstDate, 21), 'yyyy-MM-dd')}`, `${format(addDays(firstDate, 30), 'yyyy-MM-dd')}`)) {
        completedInspectionsByDate[3].push(i);
      }
    })
  }

  if (selectedDate === 'lastQuarter') {
    cancelledInspectionsByDate = [[], [], []];
    completedInspectionsByDate = [[], [], []];

    const lastQuarterStart = startOfQuarter(subQuarters(today(), 1));

    showCompleted && completedInspectionsStats.map(i => {
      if (!i.completion_date) {
        return;
      }

      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(lastQuarterStart), 'yyyy-MM-dd'), format(endOfMonth(lastQuarterStart), 'yyyy-MM-dd'))) {
        data[0].push(i);
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'))) {
        data[1].push(i);
      }
      if (checkDateInRange(format(new Date(i.completion_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'))) {
        data[2].push(i);
      }
    })

    showCancelled && cancelledInspectionsStats.map(i => {
      if (!i.cancellation_date) {
        return;
      }

      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(lastQuarterStart), 'yyyy-MM-dd'), format(endOfMonth(lastQuarterStart), 'yyyy-MM-dd'))) {
        data[0].push(i);
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 1)), 'yyyy-MM-dd'))) {
        data[1].push(i);
      }
      if (checkDateInRange(format(new Date(i.cancellation_date), 'yyyy-MM-dd'), format(startOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'), format(endOfMonth(addMonths(lastQuarterStart, 2)), 'yyyy-MM-dd'))) {
        data[2].push(i);
      }
    })
  }

  if (selectedDate === 'lastYear') {

    cancelledInspectionsByDate = [[], [], [], [], [], [], [], [], [], [], [], []];
    completedInspectionsByDate = [[], [], [], [], [], [], [], [], [], [], [], []];


    const lastYearStart = startOfMonth(subMonths(today(), 12));

    showCompleted && completedInspectionsStats.map(inspection => {
      if (!inspection.completion_date) {
        return;
      }

      for (let i = 0; i < 12; i++) {
        let inspectionDate = format(new Date(inspection.completion_date), 'yyyy-MM-dd');
        let startDate = format(startOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');
        let endDate = format(endOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');

        if (checkDateInRange(inspectionDate, startDate, endDate)) {
          completedInspectionsByDate[i].push(inspection);
        }
      }
    })

    showCancelled && cancelledInspectionsStats.map(inspection => {
      if (!inspection.cancellation_date) {
        return;
      }

      for (let i = 0; i < 12; i++) {
        let inspectionDate = format(new Date(inspection.cancellation_date), 'yyyy-MM-dd');
        let startDate = format(startOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');
        let endDate = format(endOfMonth(addMonths(lastYearStart, i)), 'yyyy-MM-dd');

        if (checkDateInRange(inspectionDate, startDate, endDate)) {
          cancelledInspectionsByDate[i].push(inspection);
        }
      }
    })
  }


  let unitsToShow = {};

  if (showOpen) {
    openInspectionsByDate[index]?.map(i => {
      if (i.unit_id) {
        if (!unitsToShow[`${i.unit_id}`]) {
          unitsToShow[`${i.unit_id}`] = { count: 1, unit: units.find(u => u.id === i.unit_id) };
        } else {
          unitsToShow[`${i.unit_id}`].count += 1;
        }
      }
    })
  }

  if (showCancelled) {
    cancelledInspectionsByDate[index]?.map(i => {
      if (i.unit_id) {
        if (!unitsToShow[`${i.unit_id}`]) {
          unitsToShow[`${i.unit_id}`] = { count: 1, unit: units.find(u => u.id === i.unit_id) };
        } else {
          unitsToShow[`${i.unit_id}`].count += 1;
        }
      }
    })
  }

  if (showCompleted) {
    completedInspectionsByDate[index]?.map(i => {
      if (i.unit_id) {
        if (!unitsToShow[`${i.unit_id}`]) {
          unitsToShow[`${i.unit_id}`] = { count: 1, unit: units.find(u => u.id === i.unit_id) };
        } else {
          unitsToShow[`${i.unit_id}`].count += 1;
        }
      }
    })
  }

  let data = [];
  Object.keys(unitsToShow).map(k => data.push(unitsToShow[k]));

  return data;
}